import { API_BASE_URL } from '../constants/suggestions';

const handleResponse = async (response) => {
  const data = await response.json();
  if (!response.ok) {
    throw new Error(data.detail || `HTTP error! status: ${response.status}`);
  }
  return data;
};

export const getHistoryAPI = (token) => {
  return fetch(`${API_BASE_URL}/api/history`, {
    method: 'GET',
    headers: {
      'Authorization': `Bearer ${token}`,
    },
  }).then(handleResponse);
};

export const deleteConversationAPI = (token, conversationId) => {
  return fetch(`${API_BASE_URL}/api/history/${conversationId}`, {
    method: 'DELETE',
    headers: {
      'Authorization': `Bearer ${token}`,
    },
  }).then(handleResponse);
};
